import { render } from "./ArrowSection.vue?vue&type=template&id=4a46006e&scoped=true"
import script from "./ArrowSection.vue?vue&type=script&lang=js"
export * from "./ArrowSection.vue?vue&type=script&lang=js"

import "./ArrowSection.vue?vue&type=style&index=0&id=4a46006e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2362541812/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a46006e"]])

export default __exports__